import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"dashboard"},[_c('Header'),_c('Tabs',{staticClass:"mt-5"}),_c(VMain,{staticClass:"pt-0"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }